export const YesNoUnknown = ["Yes", "No", "Unknown"]

export const YesNo = ["Yes", "No"]

export const Statuses = ["Active", "Inactive"]
export const SearchGoalStatuses = ["Active", "Complete", "Inactive"]

export const Frequencies = ["Daily", "Weekly", "Monthly", "Other"]

export const PayRates = ["Hourly", "Annual"]
export const PreferredContactMethod = [
  "In-person (community)",
  "In-person (job site)",
  "In-person (agency)",
  "Telephone",
  "Text message",
  "Email",
]

export const JobsSortOptions = [
  { value: "Date added", field: "createdAt", order: "desc", type: "date" },
  { value: "Active", field: "ended", order: "desc", type: "boolean" },
  { value: "Ended", field: "ended", order: "asc", type: "boolean" },
]

export const typeOfContacts = [
  { name: "Loved One", code: "Loved One" },
  { name: "Friend", code: "Friend" },
  { name: "Previous Employer", code: "Previous Employer" },
  { name: "Current Employer", code: "Current Employer" },
  { name: "Probation/Parole", code: "Probation/Parole" },
  { name: "Social Services Provider", code: "Social Service Provider" },
  { name: "Other", code: "Other" },
]

export const JobEndingReasons = [
  "Quit for a better Job",
  "Quit due to ilness",
  "Quit for other reason",
  "Terminated",
  "Other",
]

export const FollowAlongSupportTypes = [
  "Preparing for first day of employment",
  "First day of employment",
  "Transporation",
  "Communication with suppervisor",
  "Benefits",
  "Emotional and employment support",
  "Emotional and recovery support",
  "MAT IOP Counseling",
  "Other",
]
export const EngagementChannels = [
  "in-person",
  "telephone",
  "video",
  "text/app message",
  "email",
  "other",
]
export const TransitionContactType = [
  { name: "Case Manager", code: "Case Manager" },
  { name: "Therapist", code: "Therapist" },
  { name: "Family Member", code: "Family Member" },
  { name: "Friend", code: "Friend" },
  { name: "Significant Other", code: "Significant Other" },
  {
    name: "Clergy Member or Spiritual Advisor",
    code: "Clergy Member or Spiritual Advisor",
  },
  { name: "Benefits Planner", code: "Benefits Planner" },
]
export const TransitionFutureContact = [
  "In-person (community)",
  "In-person (job site)",
  "In-person (agency)",
  "Telephone",
  "Text message",
  "Email",
]
